export default [
  {
    path: '/admin/account/api-keys',
    name: 'ApiKeys',
    component: () => import('@/views/Admin/Account/ApiKeys/Index.vue'),
    meta: {
      pageTitle: 'API Anahtarları',
      breadcrumb: [
        { text: 'Hesap', active: false },
        { text: 'API Anahtarları', active: true },
      ],
      resource: 'api-keys.list',
      action: 'read',
    },
  },
]
